import React from 'react'
import { Truck } from 'lucide-react'
import { WHOLESALE } from '../config/wholesale'

const WholesaleShippingEstimator: React.FC = () => {
  return (
    <section className="relative z-10" style={{ backgroundColor: '#0d0d0d' }}>
      <div className="container mx-auto px-6 py-8 max-w-6xl">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-3xl md:text-4xl font-bold !text-white font-heading">
            Wholesale Shipping Estimates
          </h2>
          <p className="mt-3 !text-white/60 font-body max-w-2xl mx-auto">
            Pre-negotiated UPS 2-Day Air rates for the 30-Pack Wholesale Kit.
          </p>
        </div>

        {/* Shipping table — inner overflow-x-auto so the 3 columns scroll
            horizontally on narrow iOS viewports instead of being clipped by
            the rounded wrapper's overflow-hidden. */}
        <div className="max-w-4xl mx-auto bg-white/5 border border-white/10 rounded-2xl overflow-hidden mb-6">
          <div className="overflow-x-auto">
          <table className="w-full min-w-[480px]">
            <thead>
              <tr className="border-b border-white/10">
                <th className="text-left px-5 md:px-6 py-4 text-sm md:text-base font-bold !text-white font-heading">
                  Destination
                </th>
                <th className="text-left px-5 md:px-6 py-4 text-sm md:text-base font-bold !text-white font-heading">
                  UPS 2-Day Est.
                </th>
                <th className="text-left px-5 md:px-6 py-4 text-sm md:text-base font-bold !text-white font-heading">
                  Cost/Tail
                </th>
              </tr>
            </thead>
            <tbody>
              {WHOLESALE.shippingZones.map((zone, index) => (
                <tr
                  key={zone.label}
                  className={index < WHOLESALE.shippingZones.length - 1 ? 'border-b border-white/5' : ''}
                >
                  <td className="px-5 md:px-6 py-3 md:py-4 text-sm md:text-base font-semibold !text-white/90">
                    {zone.label}
                  </td>
                  <td className="px-5 md:px-6 py-3 md:py-4 text-sm md:text-base !text-[#DAA520] font-semibold">
                    {zone.range}
                  </td>
                  <td className="px-5 md:px-6 py-3 md:py-4 text-sm md:text-base !text-white/60 font-body">
                    {zone.costPerTail}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="max-w-4xl mx-auto flex items-start gap-3 bg-blue-950/30 border border-blue-800/50 rounded-xl px-4 py-3">
          <Truck className="h-5 w-5 flex-shrink-0 !text-blue-300 mt-0.5" aria-hidden="true" />
          <p className="text-sm !text-blue-300 font-body leading-snug">
            {WHOLESALE.shippingDisclaimer}
          </p>
        </div>
      </div>
    </section>
  )
}

export default WholesaleShippingEstimator
